import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';
import { rtlStyle } from 'js/lib/language';

import { Button, Notification, spacing } from '@coursera/coursera-ui';
import { SvgEmail } from '@coursera/coursera-ui/svg';

import { toProgramHome } from 'bundles/enterprise-legacy-learner-home/links';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/program-home';

type Props = {
  style?: React.CSSProperties;
  programSlug: string;
  programName: string;
};

const styles = {
  icon: {
    marginRight: spacing.sm,
    marginBottom: 3,
  },
};

export const PendingInvitationBanner = ({ style, programSlug, programName }: Props): JSX.Element => (
  <Notification
    type="info"
    // coursera-ui type definitions are incomplete.
    // @ts-expect-error
    style={style}
    hideIcon
    message={[
      <SvgEmail key="icon" suppressTitle size={24} color="var(--cds-color-blue-600)" style={rtlStyle(styles.icon)} />,
      <FormattedHTMLMessage
        key="text"
        message={_t('<strong>You have 1 pending invitation for the learning program:</strong> {programName}')}
        programName={programName}
      />,
    ]}
    action={_t('Join Program')}
    actionRenderer={(actionText) => (
      <Button
        key="join"
        tag={TrackedLink2}
        type="primary"
        size="sm"
        htmlAttributes={{
          href: toProgramHome(programSlug),
          'aria-label': _t('Join #{programName}', { programName }),
          // coursera-ui type definitions are incomplete.
          // @ts-expect-error
          trackingName: 'pending_invitation_banner_join_link',
          data: { programSlug, programName },
        }}
      >
        {actionText}
      </Button>
    )}
  />
);

export default PendingInvitationBanner;
